const DESIGN_YOUR_BAG_CONSTANTS = {
  UPDATE_FORM_VALUES: 'UPDATE_FORM_VALUES',
  SWITCH_DELIVERY_METHODS: 'SWITCH_DELIVERY_METHODS',
  SET_FIT_VALUES: 'SET_FIT_VALUES',
  LOAD_DESIGN_YOUR_BAG: 'LOAD_DESIGN_YOUR_BAG',
  SET_ALTERNATE_BRAND: 'SET_ALTERNATE_BRAND',
  SET_CURRENT_COLOR_ENTRY: 'SET_CURRENT_COLOR_ENTRY',
  SET_SIZE_LIST: 'SET_SIZE_LIST',
  SET_IS_UPDATE_REQUIRED: 'SET_IS_UPDATE_REQUIRED',
  SET_SHOW_UPDATE_OR_CANCEL: 'SET_SHOW_UPDATE_OR_CANCEL',
  SET_FORM_NAME: 'SET_FORM_NAME',
  ADD_PRODUCT_TO_COLLECTION: 'ADD_PRODUCT_TO_COLLECTION',
  UPDATE_COLLECTIONS: 'UPDATE_COLLECTIONS',
  INCREASE_QUANTITY_IN_COLLECTIONS: 'INCREASE_QUANTITY_IN_COLLECTIONS',
  DECREASE_QUANTITY_IN_COLLECTIONS: 'DECREASE_QUANTITY_IN_COLLECTIONS',
  UPDATE_OR_CANCEL_PRODUCT_IN_COLLECTION: 'UPDATE_OR_CANCEL_PRODUCT_IN_COLLECTION',
  SET_PRODUCT: 'SET_PRODUCT',
  RESET_DESIGN_YOUR_BAG_DATA: 'RESET_DESIGN_YOUR_BAG_DATA',
  REMOVE_PRODUCT_FROM_COLLECTIONS: 'REMOVE_PRODUCT_FROM_COLLECTIONS',
  RESET_PRODUCT_DATA: 'RESET_PRODUCT_DATA',
  REMOVE_DEPARTMENT: 'REMOVE_DEPARTMENT',
  ADD_ITEM_TO_COLLECTION: 'ADD_ITEM_TO_COLLECTION',
  REMOVE_ADDED_PRODUCTS: 'REMOVE_ADDED_PRODUCTS',
};

export default DESIGN_YOUR_BAG_CONSTANTS;
